import { useEffect, useState } from 'react';
import { useApi } from '@/hooks/use-api';

/**
 * Fetches a single record from the generic directory endpoint
 * (`/api/directory/{collection}/{id}`). Replaces the old mockData `.find()`
 * lookups on every detail page so they show real, linked data + honest
 * loading / not-found states.
 */
export const useDirectoryItem = (collection, id) => {
  const api = useApi();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) { setLoading(false); return; }
    let active = true;
    setLoading(true);
    api.get(`/api/directory/${collection}/${id}`)
      .then((d) => { if (active) setItem(d?.item || d || null); })
      .catch(() => { if (active) setItem(null); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collection, id]);

  return { item, loading };
};

export default useDirectoryItem;
